// Zod-free leaf module: plain enums only (RET1-2734). Keep this file free of
// imports so lean bundles can use these values without loading zod schemas.

export enum ReturnMetadataLockKey {
  BIGCOMMERCE_CREATE_SC_PURCHASE_ORDER = "bigcommerce-create-sc-purchase-order",
  SHOPIFY_CREATE_DRAFT_STORE_CREDIT_ORDER = "shopify-create-draft-store-credit-order",
  RETURN_PROCESSED_EMAIL_SENT = "return-processed-email-sent",
  DISCOUNT_CODE_CREATED = "discount_code_created",
  RISE_CREDIT_ISSUED = "rise_credit_issued",
  LOOPZ_CREDIT_ISSUED = "loopz_credit_issued",
  CREDITSYARD_CREDIT_ISSUED = "creditsyard_credit_issued",
  STORE_CREDIT_EMAILED = "store_credit_emailed",
  GIFT_CARD_CREATED = "gift_card_created",
  SHOPIFY_ACCOUNT_CREDIT_ISSUED = "shopify_account_credit_issued",
  STORE_CREDIT_ORDER_ATTRIBUTES_UPDATED = "store_credit_order_attributes_updated",
  STORE_CREDIT_ORDER_NOTES_UPDATED = "store_credit_order_notes_updated",
  MASKED_CODE = "masked_code",
  BIGCOMMERCE_STORE_CREDIT_ISSUED = "bigcommerce_store_credit_issued",
  BIGCOMMERCE_GIFT_CERTIFICATE_ISSUED = "bigcommerce_gift_certificate_issued",
  MERCHANT_CREDITED_FOR_MANAGED_CLAIM = "merchant-credited-for-managed-claim",
  BIGCOMMERCE_INVENTORY_ADJUSTED_STORE_CREDIT = "bigcommerce-inventory-adjusted-store_credit",
  BIGCOMMERCE_INVENTORY_ADJUSTED_REFUND = "bigcommerce-inventory-adjusted-refund",
  BIGCOMMERCE_INVENTORY_ADJUSTED_EXCHANGE = "bigcommerce-inventory-adjusted-exchange",
  BIGCOMMERCE_INVENTORY_ADJUSTED = "bigcommerce-inventory-adjusted",
  SFCC_EXCHANGE_ORDER_CREATED = "sfcc-exchange-order-created",
  SFCC_EXCHANGE_ORDER_PLACED = "sfcc-exchange-order-placed",
  APTOS_EXCHANGE_ORDER_CREATED = "aptos-exchange-order-created",
  OOS_GIFT_CARD_CREATED = "oos_gift_card_created",
  OOS_DISCOUNT_CODE_CREATED = "oos_discount_code_created",
  OOS_SHOPIFY_ACCOUNT_CREDIT_ISSUED = "oos_shopify_account_credit_issued",
  OOS_STORE_CREDIT_EMAILED = "oos_store_credit_emailed",
  OOS_STORE_CREDIT_ORDER_ATTRIBUTES_UPDATED = "oos_store_credit_order_attributes_updated",
  OOS_STORE_CREDIT_ORDER_NOTES_UPDATED = "oos_store_credit_order_notes_updated",
  DONATION_MATCH_ID = "donation_match_id",
  BUBBLEHOUSE_LOYALTY_POINTS_ISSUED = "bubblehouse_loyalty_points_issued",
  STORE_CREDIT_ISSUED_VIA_RETURN_PROCESS = "store_credit_issued_via_return_process",
  RESET_NATIVE_EXCHANGE_KEPT = "reset_native_exchange_kept",
}

// FedEx Pickup locations
export enum PickupLocation {
  FRONT_DOOR = "FRONT",
  BACK_DOOR = "REAR",
  SIDE_DOOR = "SIDE",
  OTHER = "NONE",
}

export enum EditableReturnProductType {
  STORE_CREDIT = "store_credit",
  REFUND = "refund",
  EXCHANGE = "exchange",
  EXCHANGE_STORE_CREDIT = "exchange_store_credit",
  EXCHANGE_REFUND = "exchange_refund",
}

export enum InstantRefundStatus {
  PENDING = "pending",
  PAYMENT_FAILED = "payment_failed",
  PAID = "paid",
  PROCESSED = "processed",
  EXPIRED = "expired",
}

export enum ClaimResult {
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  PENDING = "PENDING",
}

export enum FileShippingClaimWithSSResult {
  SUCCESS = "success",
  CLAIM_ALREADY_EXISTS = "claim_already_exists",
  FAILED_TO_FILE = "failed_to_file",
}

export enum ExternalClaimStatus {
  NEW = "new",
  CLOSED = "closed",
  UNDER_REVIEW = "under_review",
  PENDING_DOCS = "pending_docs",
  PAID = "paid",
  CANCELLED = "cancelled",
  EXPIRED = "expired",
  PENDING_PREMIUMS = "pending_premiums",
  // Shipsurance "Under Review" decision substatuses (ClaimStatusHistory API)
  SUBMIT_TO_PAY = "submit_to_pay",
  SUBMIT_TO_PAY_APPROVED = "submit_to_pay_approved",
  SUBMIT_TO_PAY_NOT_APPROVED = "submit_to_pay_not_approved",
  SUBMIT_TO_CLOSE = "submit_to_close",
}

// value set {exchange,refund,store_credit} coincides with the unrelated compensation_method DB enum //redontIgnore
export enum ReturnTypes {
  STORE_CREDIT = "store_credit",
  REFUND = "refund",
  EXCHANGE = "exchange",
}

export enum ExchangeInvoiceReminderEmailTrigger {
  AUTOMATED = "AUTOMATED",
  MANUAL = "MANUAL",
}

export enum WorkflowStatus {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}
